// Utility to export JSON data to Excel using SheetJS
import * as XLSX from 'xlsx';


// Export Users: skip birthday, profileImageUrl, id, phoneNumber
export function exportUsersToExcel(data, filename = 'users.xlsx') {
  const filteredData = data.map(user => {
    const { birthday, profileImageUrl, id, phoneNumber, ...rest } = user;
    let createdAt = rest.createdAt;
    if (createdAt && typeof createdAt === 'object' && createdAt.toDate) {
      createdAt = createdAt.toDate().toLocaleString();
    } else if (createdAt instanceof Date) {
      createdAt = createdAt.toLocaleString();
    }
    return {
      ...rest,
      createdAt: createdAt || '',
    };
  });
  const worksheet = XLSX.utils.json_to_sheet(filteredData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
  XLSX.writeFile(workbook, filename);
}

// Export Subscriptions: skip formattedStartDate, formattedValidityDate, createdAt, paymentMethod, isActive
export function exportSubscriptionsToExcel(data, filename = 'subscriptions.xlsx') {
  const filteredData = data.map(sub => {
    const { id, phoneNumber, userName, formattedStartDate, formattedValidityDate, createdAt, paymentMethod, isActive, ...rest } = sub;
    return { userName, phoneNumber, ...rest };
  });
  const worksheet = XLSX.utils.json_to_sheet(filteredData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Subscriptions');
  XLSX.writeFile(workbook, filename);
}

// Export Birthdays: exclude internal fields
export function exportBirthdaysToExcel(data, filename = 'birthdays.xlsx') {
  const filteredData = data.map(user => {
    // Exclude id, totalBirthdays, createdAt, and internal array data
    const { id, totalBirthdays, createdAt, birthdays, ...rest } = user;
    return { ...rest };
  });
  const worksheet = XLSX.utils.json_to_sheet(filteredData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Birthdays');
  XLSX.writeFile(workbook, filename);
}
